import React from 'react';
import { Show } from '@refinedev/antd';
import { useShow } from '@refinedev/core';
import { Tag, theme } from 'antd';
import { Field } from '../../components/Field';
import { LocalizedContentShow } from '../../components/LocalizedContentTabs';

interface LevelDto {
  id: string;
  levelNumber: number;
  title: string;
  translations?: Record<string, { title?: string }> | null;
  requiredXp: number;
  rewardCoins: number;
  rewardBadgeId?: string | null;
  iconUrl?: string | null;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

const tagStyle = (color: string) => ({
  borderColor: color,
  color,
  background: `${color}15`,
  borderRadius: 9999,
  padding: '2px 12px',
  fontWeight: 500,
});

export const LevelShow: React.FC = () => {
  const { token } = theme.useToken();
  const { queryResult } = useShow<LevelDto>({ resource: 'levels' });
  const item = queryResult?.data?.data;

  if (!item) {
    return <div style={{ color: token.colorTextSecondary }}>Loading...</div>;
  }

  return (
    <Show resource="levels">
      <div style={{ padding: '8px 0' }}>
        <LocalizedContentShow
          record={item}
          fields={[{ key: 'title', label: 'Title' }]}
        />

        <div
          style={{
            borderTop: `1px solid ${token.colorBorderSecondary}`,
            paddingTop: 16,
          }}
        >
          <Field label="Level Number">{item.levelNumber}</Field>
          <Field label="Required XP">{item.requiredXp}</Field>
          <Field label="Reward Coins">{item.rewardCoins}</Field>
          {item.rewardBadgeId && <Field label="Reward Badge ID">{item.rewardBadgeId}</Field>}
          {item.iconUrl && (
            <Field label="Icon">
              <a href={item.iconUrl} target="_blank" rel="noreferrer">{item.iconUrl}</a>
            </Field>
          )}
          <Field label="Active">
            <Tag style={tagStyle(item.isActive ? '#3ecf8e' : '#898989')}>
              {item.isActive ? 'Active' : 'Inactive'}
            </Tag>
          </Field>
          <Field label="Created At">{new Date(item.createdAt).toLocaleString()}</Field>
          <Field label="Updated At">{new Date(item.updatedAt).toLocaleString()}</Field>
        </div>
      </div>
    </Show>
  );
};
